import { render, staticRenderFns } from "./UsefulResources.vue?vue&type=template&id=364d330b&"
import script from "./UsefulResources.vue?vue&type=script&lang=js&"
export * from "./UsefulResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports